import {AbstractModel} from '../../../abstract-model';
import {ThemeSchemaElement} from './theme-schema-element';

export class ThemeSchemaStyle extends AbstractModel implements ThemeSchemaElement {
  key: string = '';
  styleType: string = '';
  description: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);


    return this;
  }

  getType(): string {
    return 'style';
  }
}
